import React, { useEffect, useMemo } from 'react';
import { getNavigation } from '@plone/volto/actions';
import { getBaseUrl, hasApiExpander } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { useDispatch, useSelector } from 'react-redux';

import HeaderMenu from 'volto-ministerio-publico-federal/components/Header';

const Navigation = ({ pathname }) => {
  const dispatch = useDispatch();

  const items = useSelector((state) => state.navigation?.items);
  const token = useSelector((state) => state.userSession.token);

  useEffect(() => {
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), config.settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  return useMemo(() => {
    return <HeaderMenu pathname={pathname} props={{ items }} />;
  }, [pathname, items]);
};

export default Navigation;
